var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrizePoolOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 61,
    viewBox: "0 0 267 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01006 60.87C4.55006 60.87 2.32006 59.62 1.04006 57.53C-0.239938 55.44 -0.339938 52.88 0.770063 50.69L10.8701 30.89C11.0101 30.6 11.0101 30.27 10.8701 29.98L0.770063 10.18C-0.339938 8 -0.249938 5.44 1.04006 3.34C2.32006 1.25 4.55006 0 7.01006 0H259.47C261.93 0 264.16 1.25 265.44 3.34C266.72 5.43 266.82 7.99 265.7 10.18L255.6 29.97C255.46 30.26 255.46 30.59 255.6 30.88L265.7 50.68C266.82 52.87 266.72 55.42 265.44 57.52C264.16 59.61 261.93 60.86 259.47 60.86H7.01006V60.87Z",
    fill: "#061436"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizePoolOuter);
export default __webpack_public_path__ + "static/media/prizePoolOuter.150d155baf544a17f1483ec75b3cf0c1.svg";
export { ForwardRef as ReactComponent };